var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-default-svg-from-material-design',{attrs:{"size":_vm.size,"path":_vm.headerPaths[_vm.value]}})
}
var staticRenderFns = []

export { render, staticRenderFns }